import React, { Suspense, lazy, useEffect } from 'react';
import './index.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import ScrollManager from './components/ScrollManager';
import ScrollIndicator from './components/ScrollIndicator';
import SectionHeightAdjuster from './components/SectionHeightAdjuster';

const About = lazy(() => import('./components/About'));
const Services = lazy(() => import('./components/Services'));
const Technologies = lazy(() => import('./components/Technologies'));
const Projects = lazy(() => import('./components/Projects'));
const Contact = lazy(() => import('./components/Contact'));
const Footer = lazy(() => import('./components/Footer'));
const ParticleBackground = lazy(() => import('./components/3D/ParticleBackground'));

const SectionFallback = () => (
  <div className="min-h-[40vh] bg-[#f5f5f5]" aria-hidden />
);

function App() {
  useEffect(() => {
    const isMobile = () =>
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
      window.innerWidth <= 768;

    if (!isMobile()) {
      document.querySelectorAll('section').forEach((section) => {
        if (section.id !== 'footer') {
          section.style.minHeight = '100vh';
        }
      });
    }
  }, []);

  return (
    <div className="App bg-[#f5f5f5] text-[#0e1c36] min-h-screen overflow-x-hidden">
      <a href="#main-content" className="skip-link">
        Aller au contenu
      </a>
      <Suspense fallback={null}>
        <ParticleBackground />
      </Suspense>
      <Navbar />
      <ScrollManager />
      <ScrollIndicator />
      <SectionHeightAdjuster />

      <main id="main-content" style={{ position: 'relative', zIndex: 1 }} tabIndex={-1}>
        <Hero />
        <Suspense fallback={<SectionFallback />}>
          <About />
        </Suspense>
        <Suspense fallback={<SectionFallback />}>
          <Services />
        </Suspense>
        <Suspense fallback={<SectionFallback />}>
          <Technologies />
        </Suspense>
        <Suspense fallback={<SectionFallback />}>
          <Projects />
        </Suspense>
        <Suspense fallback={<SectionFallback />}>
          <Contact />
        </Suspense>
      </main>

      <Suspense fallback={null}>
        <Footer />
      </Suspense>
    </div>
  );
}

export default App;
